import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { SearchAggregationMetricType, } from 'shared/domains/apollo/generated/types';
import { getMetricTypeTranslations, allowedPropertiesTranslations } from './translations';
import { ConfigMenu } from '../ConfigMenu';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function MetricInput(props) {
    const { pathBase, remove } = props;
    const currentPath = `${pathBase}.metricInput`;
    const [field, , helpers] = useField(currentPath);
    const handleChangeType = (val) => {
        helpers.setValue(Object.assign(Object.assign({}, field.value), { type: val }));
    };
    return (<FieldInputContainer>
      <SelectDataPoint label={t({ message: 'Metric', comment: 'Insights widget form: Metric field' })} selectedValue={allowedPropertiesTranslations(field.value.field)} name={pathBase} onRemove={remove}/>

      <ConfigMenu label={t({ message: 'Config', comment: 'Insights: Metric configuration' })} secondary={getMetricTypeTranslations(field.value.type)}>
        {Object.values(SearchAggregationMetricType).map((val) => (<Menu.ItemRadio key={val} onChange={() => handleChangeType(val)} checked={val === field.value.type}>
            {getMetricTypeTranslations(val)}
          </Menu.ItemRadio>))}
      </ConfigMenu>
    </FieldInputContainer>);
}
